import { render, staticRenderFns } from "./PageViewOrders.vue?vue&type=template&id=021eb469&"
import script from "./PageViewOrders.vue?vue&type=script&lang=ts&"
export * from "./PageViewOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports